import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Button, ChevronRight, CloseIcon, FilterIcon, InputUI, ItemsList, SortByIcon, Typography } from "@parkschannel/ui";
import classNames from "classnames";
import { useForm } from "react-hook-form";
export function AdvancedFiltersView(param) {
    let { onFilter , onCancel , onStatesClick , onTagsClick , onSortChange , onClear , states , tags , children , sortBy  } = param;
    const allFiltersLength = tags.length + states.length;
    return /*#__PURE__*/ _jsxs("section", {
        className: "flex flex-col gap-2 justify-between h-full",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col mb-4",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center gap-2 mb-4",
                                children: [
                                    /*#__PURE__*/ _jsx(SortByIcon, {
                                        className: "w-4 h-4 text-neutral-700"
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        component: "h4",
                                        variant: "bodyLarge",
                                        className: "text-neutral-700 mt-1",
                                        children: "Sort by"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(AdvancedSortFilters, {
                                onChange: onSortChange,
                                initialSortBy: sortBy
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex justify-between items-center mb-4 py-2",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ _jsx(FilterIcon, {
                                        className: "w-4 h-4 text-neutral-700"
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        component: "h4",
                                        variant: "bodyLarge",
                                        className: "text-neutral-700 mt-1",
                                        children: "Filters"
                                    })
                                ]
                            }),
                            allFiltersLength > 0 ? /*#__PURE__*/ _jsx("button", {
                                onClick: onClear,
                                className: "text-[11px] underline text-neutral-700",
                                children: "clear all"
                            }) : null
                        ]
                    }),
                    children,
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-4 mt-8",
                        children: [
                            /*#__PURE__*/ _jsx(AdvancedFiltersViewButton, {
                                onClick: onStatesClick,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "bodyLarge",
                                            className: "text-neutral-900 font-medium",
                                            children: "State"
                                        }),
                                        states.length === 0 ? null : /*#__PURE__*/ _jsx(Indicator, {
                                            children: states.length
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(AdvancedFiltersViewButton, {
                                onClick: onTagsClick,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "bodyLarge",
                                            className: "text-neutral-900 font-medium",
                                            children: "Tags"
                                        }),
                                        tags.length === 0 ? null : /*#__PURE__*/ _jsx(Indicator, {
                                            children: tags.length
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-4 mt-4 w-full",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "base",
                        onClick: onCancel,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        onClick: onFilter,
                        className: "w-full",
                        children: "Find Parks"
                    })
                ]
            })
        ]
    });
}
export function AdvancedSelectedFilters(param) {
    let { onStateRemove , onTagRemove , states , tags  } = param;
    const allFiltersLength = tags.length + states.length;
    if (allFiltersLength === 0) {
        return /*#__PURE__*/ _jsx(AdvancedSingleFilter, {
            title: "No filters chosen"
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ItemsList, {
                noItemsMessage: "",
                liClassName: "!w-fit",
                noItemsClassName: "!hidden",
                className: "flex gap-2 flex-wrap mb-2",
                items: states.map((state)=>({
                        id: state,
                        value: state
                    })),
                renderItem: (state)=>/*#__PURE__*/ _jsx(AdvancedSingleFilter, {
                        title: state.value,
                        onClick: ()=>onStateRemove(state.id)
                    })
            }),
            /*#__PURE__*/ _jsx(ItemsList, {
                noItemsMessage: "",
                liClassName: "!w-fit",
                noItemsClassName: "!hidden",
                className: "flex gap-2 flex-wrap",
                items: tags.map((tag)=>({
                        id: tag,
                        value: tag
                    })),
                renderItem: (tag)=>/*#__PURE__*/ _jsx(AdvancedSingleFilter, {
                        title: tag.value,
                        onClick: ()=>onTagRemove(tag.id)
                    })
            })
        ]
    });
}
function AdvancedSingleFilter(param) {
    let { title , onClick  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex gap-2 items-center px-4 py-2 bg-neutral-100 rounded-full w-fit",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "bodySmall",
                className: classNames({
                    "text-neutral-700": onClick,
                    "text-neutral-400": !onClick
                }),
                children: title
            }),
            onClick ? /*#__PURE__*/ _jsx("button", {
                className: "w-4 h-4 flex justify-center items-center",
                onClick: onClick,
                children: /*#__PURE__*/ _jsx(CloseIcon, {
                    className: "w-2 h-2"
                })
            }) : null
        ]
    });
}
function Indicator(param) {
    let { children  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "text-white rounded-full px-[7px] border-2 border-white text-xs bg-blue-500",
        children: children
    });
}
function AdvancedFiltersViewButton(param) {
    let { onClick , children  } = param;
    return /*#__PURE__*/ _jsxs("button", {
        className: "w-full bg-neutral-100 px-2 py-3 rounded-lg flex justify-between items-center hover:bg-neutral-50",
        onClick: onClick,
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: children
            }),
            /*#__PURE__*/ _jsx(ChevronRight, {
                className: "w-5 h-5 text-neutral-700"
            })
        ]
    });
}
function AdvancedSortFilters(param) {
    let { initialSortBy , onChange  } = param;
    const { register  } = useForm({
        defaultValues: {
            sortBy: initialSortBy
        }
    });
    const handleOnChange = (e)=>{
        var _value;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        onChange((_value = e.target.value) !== null && _value !== void 0 ? _value : "name:ASC");
    };
    return /*#__PURE__*/ _jsxs("form", {
        className: "flex flex-col gap-2",
        onChange: handleOnChange,
        children: [
            /*#__PURE__*/ _jsx(InputUI.Radio, {
                id: "name:ASC",
                htmlFor: "name:ASC",
                value: "name:ASC",
                text: "park name (A - Z)",
                ...register("sortBy")
            }),
            /*#__PURE__*/ _jsx(InputUI.Radio, {
                id: "name:DESC",
                htmlFor: "name:DESC",
                value: "name:DESC",
                text: "park name (Z - A)",
                ...register("sortBy")
            }),
            /*#__PURE__*/ _jsx(InputUI.Radio, {
                id: "videosCount:DESC",
                htmlFor: "videosCount:DESC",
                value: "videosCount:DESC",
                text: "number of videos (desc)",
                ...register("sortBy")
            }),
            /*#__PURE__*/ _jsx(InputUI.Radio, {
                id: "creatorsCount:DESC",
                htmlFor: "creatorsCount:DESC",
                value: "creatorsCount:DESC",
                text: "number of creators (desc)",
                ...register("sortBy")
            })
        ]
    });
}
